import { useMemo, useState, type ChangeEvent, type FocusEvent } from 'react';
import { useTranslation } from 'react-i18next';
import './ShareLinkBox.css';

interface SecretInputBoxProps {
  value: string;
  masked?: boolean;
  allowToggleMask?: boolean;
  ariaLabel?: string;
  readOnly?: boolean;
  required?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
}

export default function SecretInputBox({
  value,
  masked = false,
  allowToggleMask = false,
  ariaLabel,
  readOnly,
  required,
  onChange,
  onFocus
}: SecretInputBoxProps) {
  const { t } = useTranslation();
  const [show, setShow] = useState(!masked);
  const inputType = show ? 'text' : 'password';
  const canToggle = allowToggleMask;
  const displayValue = useMemo(() => value, [value]);

  return (
    <div className="share-link-input-wrapper">
      <input
        type={inputType}
        value={displayValue}
        readOnly={readOnly}
        aria-label={ariaLabel}
        onFocus={onFocus}
        onChange={onChange}
        required={required}
        className="share-link-input"
      />
      {canToggle && (
        <button
          type="button"
          className="share-link-toggle"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? t('share.hide') : t('share.show')}
        >
          {show ? (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              />
              <circle cx="12" cy="12" r="3" fill="currentColor" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              />
              <circle cx="12" cy="12" r="3" fill="currentColor" />
              <line
                x1="4"
                y1="4"
                x2="20"
                y2="20"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          )}
        </button>
      )}
    </div>
  );
}
